export default __webpack_public_path__ + "static/cw-bc98be54a4fcb75536420a08e625e31e.svg";